import { Table, Tag } from "antd";
import type { TableColumnsType } from "antd";

const DateCell = ({ date }: any) => {
  return <div style={{ fontSize: "12px", color: "grey" }}>{date}</div>;
};

const LogsTable = ({ data }: any) => {
  const projectList: any = Array.from(
    new Set(data?.map((e: any) => e?.projectName))
  )?.map((e: any) => {
    return { text: e, value: e };
  });
  const taskList: any = Array.from(
    new Set(data?.map((e: any) => e?.taskName))
  )?.map((e: any) => {
    return { text: e, value: e };
  });


  const columns: TableColumnsType<any> = [
    {
      title: "S.No",
      dataIndex: "key",
      width: "4%",
      // sorter: (a, b) => a.age - b.age,
    },
    {
      title: "Work Date",
      dataIndex: "workDate",
      render: (value) => {
        let date = new Date(value);
        return (
          <Tag color="green">
            <DateCell date={date.toLocaleDateString("en-US")} />
          </Tag>
        );
      },
    },
    {
      title: "Project Name",
      dataIndex: "projectName",
      filters: projectList,
      // filterMode: "tree",
      filterSearch: true,
      onFilter: (value, record) =>
        record?.projectName?.startsWith(value as string),
      width: "15%",
      render: (value) => {
        return <Tag color="blue">{value}</Tag>;
      },
    },
    {
      title: "Work Hrs",
      dataIndex: "totalhours",
      render: (value) => {
        return (
          <Tag color="#87d068" style={{ fontWeight: "bold", fontSize: "14px" }}>
            {value}
          </Tag>
        );
      },
    },
    {
      title: "Task Name",
      dataIndex: "taskName",
      filters: taskList,
      onFilter: (value, record) =>
        record?.taskName?.startsWith(value as string),
      filterSearch: true,
      width: "15%",
    },
    {
      title: "Sub Task",
      dataIndex: "subTaskName",
      width: "15%",
      render: (value, record) => {
        return (
          <span style={{ color: "grey" }}>
            {record?.subTask ? (
              <Tag color="cyan">{record?.subTask || ""}</Tag>
            ) : (
              ""
            )}
            <div>{value}</div>
          </span>
        );
      },
    },
    {
      title: "Description",
      dataIndex: "comments" ,
      render: (value) => {
        return (
          <div style={{ fontSize: "13px", color: "gray" }}>
            <div dangerouslySetInnerHTML={{ __html: value }} />
          </div>
        );
      },
      width: "30%",
    },
    {
      title: "Logged Date",
      dataIndex: "createdAt",
      render: (value) => {
        let date = new Date(value);
        return (
          <DateCell
            date={
              date.toLocaleDateString("en-US") +
              " " +
              date.toLocaleTimeString("en-US")
            }
          />
        );
      },
    },
  ];

  // const onChange: TableProps<any>['onChange'] = (pagination, filters, sorter, extra) => {
  //   console.log('params', pagination, filters, sorter, extra);
  // };
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Table columns={columns} dataSource={data} scroll={{ y: 560 }} />
    </div>
  );
};

export default LogsTable;
